<template>
    <div class="flex justify-between">
        <div class="flex items-center">
            <IconCheck v-if="status === 'completed'" class="inline mr-2 text-green-400 flex-shrink-0" />
            <div>
                <h2 class="font-bold text-base desktop:text-lg">
                    {{ heading }}
                </h2>
                <p
                    class="font-book text-sm desktop:text-base"
                    v-if="showDescription">
                    {{ description }}
                </p>
            </div>
        </div>
        <button v-if="canEdit && !open && status === 'completed'" @click.prevent="$emit('edit')"
                type="button"
                class="btn-primary-sm text-sm widescreen:text-base ml-6 my-auto">
            Edit
        </button>
        <button v-else-if="canEdit && open && status === 'completed'" @click.prevent="$emit('cancel-edit')"
                type="button"
                class="btn-primary-sm text-sm widescreen:text-base ml-6 my-auto">
            Cancel&nbsp;Edit
        </button>
    </div>
</template>

<script>
import IconCheck from "@/atoms/icons/IconCheck"
export default {
    name: 'CheckoutCardBar',
    components: {
        IconCheck,
    },
    props: {
        open: {
            type: Boolean,
            default: false,
        },
        status: {
            type: String,
            default: 'uncompleted',
        },
        heading: {
            type: String,
            default: '',
        },
        description: {
            type: String,
            default: '',
        },
        showDescription: {
            type: Boolean,
            default: true,
        },
        canEdit: {
            type: Boolean,
            default: true,
        },
    },
}
</script>
